import {
  AKHAND_PATH_RECITE_MAILTO,
  AKHAND_PATH_RECORDINGS,
  AKHAND_PATH_SWARVED_HREF,
} from "../../content/activities";
import { t } from "../../i18n/dict";
import { Page } from "../../layout/Page";
import { Button } from "../../ui/Button";
import { Card } from "../../ui/Card";
import { Reveal } from "../../ui/Reveal";
import { Section } from "../../ui/Section";

/**
 * The old site's `/swarved-24-hr-recitation` (its own title: "Swarved
 * 24-hr Recitation"; the new route is `/activities/swarved-akhand-path`):
 * the "Know more about Swarved" and "I Want to Recite" buttons, then the
 * past Akhand Path recordings, newest first, verbatim dates and Facebook
 * links. The stale "(Upcoming) 27 Jan 2024" entry from the old site is
 * dropped - see the doc comment on `AKHAND_PATH_RECORDINGS`. English
 * only - no Hindi twin.
 */
export function AkhandPathPage() {
  return (
    <Page title="Swarved Akhand Path" heading="Swarved Akhand Path">
      <Section>
        <div className="flex flex-wrap gap-3">
          <Button href={AKHAND_PATH_SWARVED_HREF} variant="secondary">
            Know more about Swarved
          </Button>
          <Button href={AKHAND_PATH_RECITE_MAILTO}>
            {t("en", "iWantToRecite")}
          </Button>
        </div>
        <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {AKHAND_PATH_RECORDINGS.map((recording) => (
            <Reveal key={recording.href}>
              <Card
                title={recording.date}
                cta={{
                  label: t("en", "watchRecording"),
                  href: recording.href,
                  external: true,
                }}
              />
            </Reveal>
          ))}
        </div>
      </Section>
    </Page>
  );
}
